import { ColumnModel } from "app/services/api/types/common/models/ColumnModel";
import { ViewStyle } from "react-native";

/**
 * Calculates the total fractional units (fr) from an array of column widths
 */
export function calculateTotalFr(columnWidths: string[]): number {
  return columnWidths.reduce((sum, width) => {
    const w = width || "1fr";
    const match = w.match(/^(\d+(?:\.\d+)?)fr$/);
    return sum + (match ? parseFloat(match[1] ?? "0") : 0);
  }, 0);
}

/**
 * Converts a column width string to a React Native style object
 * Supports: fr units (e.g., "1fr", "2fr"), px units, % units
 */
export function getColumnStyle(
  width: string,
  totalFr: number,
  totalColumns: number,
  minWidth?: number,
): ViewStyle {
  const style: ViewStyle = {};

  if (width.endsWith("fr")) {
    const frValue = parseFloat(width);
    style.flex = totalFr > 0 ? frValue / totalFr : 1 / totalColumns;
  } else if (width.endsWith("px")) {
    style.width = parseFloat(width);
    style.flexShrink = 0;
  } else if (width.endsWith("%")) {
    style.width = width as `${number}%`;
    style.flexShrink = 0;
  } else {
    style.flex = 1 / totalColumns;
  }

  if (minWidth) {
    style.minWidth = minWidth;
  }
  return style;
}

/**
 * Extracts column widths from an array of columns, defaulting to "1fr"
 */
export function getColumnWidths<T>(columns: ColumnModel<T>[]): string[] {
  return columns.map((col) => col.width || "1fr");
}
